export default __webpack_public_path__ + "b670552cb44523f05fcd8002015c95dd.jpg";